import React, { ReactElement } from "react";
import { GetServerSideProps } from "next";
import { getPageProps } from "@services/initial-calls";

import ContactTop from "@components/antiviruschoice/contactTop";
import FormSection from "@components/antiviruschoice/formSection";

import IForkLiftWrapper from "@components/layouts/iForkLiftWrapper";

export default function NextAutoWarrantyHome(): ReactElement {
    return (
        <IForkLiftWrapper>
            <div className={`max-w-7xl mx-auto block px-4vw lg:px-4`}>
                <div className="bg-white">
                    <ContactTop iconsFillColor="#ffe04c" />
                </div>
                <FormSection iconsFillColor="#ffe04c" />
            </div>
        </IForkLiftWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Contact Us" });
};
